var React = require('react');

function MediumInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M1.5 20.98l2.06-2.705V8.196L1.5 5.492V5h6.06l4.486 9.71L15.681 5H21.5v.492L19.682 7.09v12.168L21.5 20.98v.492h-8.242v-.492l1.939-1.72V9.916L10.712 21.47h-.727L4.894 10.286v7.989l2.424 2.704v.492H1.5v-.492z"}));
}

MediumInline.defaultProps = {"viewBox":"0 2 23 22","role":"img"};

module.exports = MediumInline;

MediumInline.default = MediumInline;
